import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import empLandingPage from "../../../assets/images/empLandingPage.png";
import fastTime from "../../../assets/images/fast-time.png";
import calender from "../../../assets/images/calendar.png";
import jobSearchImg from "../../../assets/images/job-search 2.png";
import amazon from "../../../assets/images/amazon-logo.png";
import protonshub from "../../../assets/images/protons-logo.png";
import wipro from "../../../assets/images/wipro-logo.png";
import shekunj from "../../../assets/images/shekunj-logo.svg";
import tcs from "../../../assets/images/tcs-logo.png";
import infosys from "../../../assets/images/infosys-logo.png";
import Layout from "../../components/Layout/Layout";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setPortalInfo } from "../../../redux/globalSlice";
import { returnRoleValue } from "../../../utils";
import "./index.scss";
import { Paper } from "@mui/material";
import { Helmet } from "react-helmet-async";

const Employer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const portal = localStorage.getItem("portal");
  const handleNavigation = () => {
    dispatch(
      setPortalInfo({
        portalName: "Employer",
        portalValue: "employer",
      })
    );
    navigate("/login");
  };
  return (
    <>
      <Helmet>
        <title>Staffing Solutions for Employers | OctaHire</title>
        <meta name="description" content="Discover efficient Staffing Solutions for Employers at Octahire. Streamline your
        hiring process with our comprehensive services. We help you to meet your staffing needs."/>
        <link rel="canonical" href="https://octahire.com/employer-landingPage" />
      </Helmet>
      <Layout>
        <section className="employer-header-section">
          <div className="ehs-left-section">
            <div className="ls-chip">
              <p>Quick & Easy Job Posting</p>
            </div>
            <div className="ls-heading">
              <h1>
                Get Quality Applies at <span>Octahire</span>
              </h1>
            </div>
            <div className="ls-bullet-points">
              <ul>
                <li>Get unlimited calls directly from the candidates.</li>
                <li>
                  Get access to the database of over 3.5 Crore candidates.
                </li>
              </ul>
            </div>
            {(!token || (token && portal === "Employer")) && (
              <div className="ls-btn">
                <button type="button" onClick={() => handleNavigation()}>
                  Post Your First Job
                </button>
              </div>
            )}
          </div>
          <div className="ehs-right-section">
            <img src={empLandingPage} alt="smiling-young-businesswoman" />
          </div>
          {(!token || (token && portal === "Employer")) && (
            <div className="ls-btn-mobile">
              <button type="button" onClick={() => handleNavigation()}>
                Post Your First Job
              </button>
            </div>
          )}
        </section>
        <section className="start-posting-section">
          <Container>
            <div className="sps-heading">
              <h3>Start Posting Your Job In Few Minutes</h3>
              <p>
                Reach out to millions of jobseekers and hire quickly with our
                fast and easy job posting services.
              </p>
            </div>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4} className="sps-grid">
                <div className="sps-card">
                  <div className="card-content">
                    <img src={fastTime} alt="" />
                    <h4>2 Minutes to Post</h4>
                    <p>
                      Quick and easy job posting with screening questions to get
                      filtered candidates
                    </p>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="sps-grid">
                <div className="sps-card">
                  <div className="card-content">
                    <img src={jobSearchImg} alt="" />
                    <h4>Attract Audience</h4>
                    <p>Attract Audience from across the country</p>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="sps-grid">
                <div className="sps-card">
                  <div className="card-content">
                    <img src={calender} alt="" />
                    <h4>Get 30 days visibility</h4>
                    <p>
                      Get free visibility for portal and its features for
                      initial 30 days.
                    </p>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Container>
        </section>
        <section className="hired-companies-section">
          <div className="hcs-heading">
            <h3>Join 10,000+ companies who hire with Octahire</h3>
          </div>
          <div className="hcs-companies">
            <div>
              <img src={amazon} alt="" />
            </div>
            <div>
              <img src={infosys} alt="" />
            </div>
            <div>
              <img src={tcs} alt="" />
            </div>
            <div>
              <img src={wipro} alt="" />
            </div>
            <div>
              <img src={shekunj} alt="" />
            </div>
            <div>
              <img src={protonshub} alt="" />
            </div>
          </div>
        </section>
        {/* <Box className="end-section">
          <Container>
            <Grid container spacing={2}>
              <Grid item md={12}>
                <Box className="end-section-content">
                  <h3>Join 10,000+ companies who hire with Octahire</h3>
                </Box>
                <Box className="banner-img-section">
                  <ul>
                    <li>
                      <img src={amazon} alt="" />
                    </li>
                    <li>
                      <img src={infosys} alt="" />
                    </li>
                    <li>
                      <img src={tcs} alt="" />
                    </li>
                    <li>
                      <img src={wipro} alt="" />
                    </li>
                    <li>
                      <img src={shekunj} alt="" />
                    </li>
                    <li>
                      <img src={protonshub} alt="" />
                    </li>
                  </ul>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box> */}
      </Layout>
    </>
  );
};
export default Employer;
